export const sessionTokenKey = 'session-token';
